<template>
  <div class="page">
    <div
      class="topImg"
      :style="{
        width: isMobile ? '100%' : '',
        marginLeft: isMobile ? '0%' : '',
      }"
    >
      <template v-if="lange == 'zh'">
        <template v-if="detail.content_top.type == 1">
          <img :src="detail.content_top.url" />
        </template>
        <template v-else-if="detail.content_top.type == 2">
          <div v-html="detail.content_top.content">
            {{ detail.content_top.content }}
          </div>
        </template>
      </template>
      <template v-else-if="lange == 'xyl'">
        <template v-if="detail.hu_content_top.type == 1">
          <img :src="detail.hu_content_top.url" />
        </template>
        <template v-else-if="detail.hu_content_top.type == 2">
          <div v-html="detail.hu_content_top.content">
            {{ detail.hu_content_top.content }}
          </div>
        </template>
      </template>
      <template v-else>
        <template v-if="detail.en_content_top.type == 1">
          <img :src="detail.en_content_top.url" />
        </template>
        <template v-else-if="detail.en_content_top.type == 2">
          <div v-html="detail.en_content_top.content">
            {{ detail.en_content_top.content }}
          </div>
        </template>
      </template>
      <!-- <img src="@/assets/ysjs.png" /> -->

      <!-- 链接跳转 -->
      <div
        class="topDwOne"
        :style="{
          height: isMobile ? '30px' : '150px',
          top: '40.4%',
          right: '35.3%',
          width: '30%',
        }"
        @click="goUpload"
      ></div>
      <div
        :style="{
          height: isMobile ? '10px' : '36px',
          top: '52.4%',
          right: '20%',
          width: '11%',
        }"
        class="topDwTwo"
        @click="goContest"
      ></div>

      <div
        class="topDwtree"
        :style="{
          height: isMobile ? '20px' : '73px',
          top: '65.1%',
          right: '35.3%',
          width: '30%',
        }"
        @click="gourl"
      ></div>

      <div
        class="topDwfore"
        :style="{
          height: isMobile ? '21px' : '75px',
          top: '78%',
          right: '22%',
          width: '53%',
        }"
      >
        <div
          class="mybz"
          v-for="item in 5"
          :key="item"
          @click="clikcbz(item)"
        ></div>
      </div>

      <div
        class="topDwfive"
        :style="{
          height: isMobile ? '21px' : '75px',
          top: '79%',
          right: '22%',
          width: '53%',
        }"
      >
        <div
          class="mybz"
          v-for="item in 4"
          :key="item"
          @click="clikcbz(item + 5)"
        ></div>
      </div>

      <div
        class="cententBox"
        style="display: none"
        :style="{
          backgroundImage: `url('${
            lange == 'zh'
              ? detail.background
              : lange == 'xyl'
              ? detail.hu_background
              : detail.en_background
          }')`,
          backgroundSize: isMobile ? '140%  100.1%' : '',
          backgroundPositionX: isMobile ? '50%' : '',
        }"
      >
        <div
          class="centent"
          :style="{
            width: isMobile ? '90%' : '90%',
          }"
        >
          <div class="uploadZp">
            <div
              @click="goUpload"
              :style="{
                height: isMobile ? '30px' : '100px',
              }"
            >
              {{ $t("上传作品") }}
            </div>
          </div>
          <div class="dsgzBox">
            <div class="dsgzBoxOne">
              <div class="yuan"></div>
              <div class="dsgzBoxOneWz">
                人员限制：参赛者需为年满14周岁且居住在匈牙利或中国的匈牙利公民或外国公民（有摄影业余或专业经验均可）。其中，14至18周岁的申请人需取得父母或法定监护人的同意方可参赛。主办方主席团成员和比赛评审团成员及其近亲不得参加。
              </div>
            </div>
            <div class="dsgzBoxOne">
              <div class="yuan"></div>
              <div class="dsgzBoxOneWz">
                作品规格：参赛作品长边最高2000px，文件容量最高5MB。公布结果前，评委组有权利要求以单图参赛的参赛者提供RAW格式图片，以组图参赛的参赛者提供TIF格式图片，照片总像素不低于20
                兆。
              </div>
            </div>
            <div class="dsgzBoxOne" style="margin-top: 20px">
              <div class="yuan"></div>
              <div class="dsgzBoxOneWz">
                作品数量：参赛者可同时参与任一组别的赛事，每个组别可最多提交5幅单张照片及1个系列（3-7张）照片。
              </div>
            </div>
            <div class="dsgzBoxTwo">
              <div class="dsgzBoxTwoOne">
                想要了解更多报名信息，请点击此处查看
              </div>
              <div @click="goContest" class="dsgzBoxTwoDssm">
                《{{ $t("大赛声明") }}》
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="bahbox" :style="{ fontSize: isMobile ? '26rpx' : '26px' }">
      京ICP备17000427号-6
    </div>
  </div>
</template>

<script>
import { ysListAPI, shadowDetailAPI } from "@/api/submit";
export default {
  components: {},
  data() {
    return {
      detail: {
        background: "",
        content_top: {},
        hu_content_top: {},
      },
      lange: localStorage.getItem("i18n-lang") || "zh",
    };
  },
  mounted() {
    this.id = this.$route.query.id || "";
    if (!this.id) {
      this.getList();
    } else {
      this.getDetail();
    }
  },
  methods: {
    clikcbz(item) {
      console.log("--------------点击", item);
      switch (item) {
        case 1:
          window.open("http://hu.china-embassy.gov.cn/?lang=hu");
          break;
        case 2:
          window.open(" https://www.fotomuveszek.hu/");
          break;
        case 3:
          window.open("https://www.tradeland.hu/en/");
          break;
        case 4:
          break;
        case 5:
          break;
        case 6:
          break;
        case 7:
          break;
        case 8:
          break;
        case 9:
          window.open("https://istv.cn/");
          break;

        default:
          break;
      }
    },
    gourl() {
      window.open("http://zp2024.mkbt.hu");
    },
    goContest() {
      this.$router.push("/contest?id=" + this.id);
    },
    goUpload() {
      this.$router.push("/upload?id=" + this.id);
    },
    getDetail() {
      let data = {
        id: this.id,
      };
      const loading = this.$loading({
        lock: true,
      });
      shadowDetailAPI(data)
        .then((res) => {
          console.log(res);
          this.detail = res.data;
          document.title =
            this.lange == "zh"
              ? this.detail.title
              : this.lange == "en"
              ? this.detail.en_title
              : this.detail.hu_title;
          if (this.detail.content_top.type) {
            this.detail.content_top.content = this.removePreAndCodeTags(
              this.detail.content_top.content
            );
            this.detail.content_top.content = this.replaceAngleBrackets(
              this.detail.content_top.content
            );
            let regex = new RegExp("<img", "gi");
            this.detail.content_top.content =
              this.detail.content_top.content.replace(
                regex,
                `<img style="width: 100%;display: block;margin: 0;padding: 0;object-fit: cover;"`
              );
          }
          if (this.detail.hu_content_top.type) {
            this.detail.hu_content_top.content = this.removePreAndCodeTags(
              this.detail.hu_content_top.content
            );
            this.detail.hu_content_top.content = this.replaceAngleBrackets(
              this.detail.hu_content_top.content
            );
            let regex = new RegExp("<img", "gi");
            this.detail.hu_content_top.content =
              this.detail.hu_content_top.content.replace(
                regex,
                `<img style="width: 100%;display: block;margin: 0;padding: 0;object-fit: cover;"`
              );
          }
          if (this.detail.en_content_top.type) {
            this.detail.en_content_top.content = this.removePreAndCodeTags(
              this.detail.en_content_top.content
            );
            this.detail.en_content_top.content = this.replaceAngleBrackets(
              this.detail.en_content_top.content
            );
            let regex = new RegExp("<img", "gi");
            this.detail.en_content_top.content =
              this.detail.en_content_top.content.replace(
                regex,
                `<img style="width: 100%;display: block;margin: 0;padding: 0;object-fit: cover;"`
              );
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          loading.close();
        });
    },
    removePreAndCodeTags(htmlString) {
      const regex = /<pre[^>]*>|<code[^>]*>|<\/pre>|<\/code>/gi;
      return htmlString.replace(regex, "");
    },
    replaceAngleBrackets(str) {
      return str.replace(/&lt;/g, "<").replace(/&gt;/g, ">");
    },
    getList() {
      const loading = this.$loading({
        lock: true,
      });
      ysListAPI()
        .then((res) => {
          this.ysList = res.data;
          this.id = res.data.length > 0 ? res.data[0].id : "";
          if (this.id) {
            this.getDetail();
          }
        })
        .finally(() => {
          loading.close();
        });
    },
  },
};
</script>

<style></style>
<style scoped lang="scss">
.page {
  width: 100%;
  overflow-x: hidden;
  box-sizing: border-box;
}

.el-row {
  max-width: 100%;
  box-sizing: border-box;
  margin-left: 0 !important;
  margin-right: 0 !important;

  &:last-child {
    margin-bottom: 0;
  }
}

.topImg {
  width: 100%;
  position: relative;

  img {
    width: 100%;
    display: block;
    margin: 0;
    padding: 0;
  }

  .topDw {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.3);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #fff;
    font-weight: 500;
  }

  .topDwOne {
    position: absolute;
    cursor: pointer;
  }

  .topDwTwo {
    position: absolute;
    cursor: pointer;
  }

  .topDwtree {
    position: absolute;
    cursor: pointer;
  }

  .topDwfore {
    position: absolute;
    cursor: pointer;
    display: flex;
    flex-wrap: wrap;
    & .mybz:nth-child(1) {
      width: 12%;
    }
    & .mybz:nth-child(2) {
      width: 12%;
    }
    & .mybz:nth-child(3) {
      width: 18%;
    }
    & .mybz:nth-child(4) {
      width: 12%;
    }
    & .mybz:nth-child(5) {
      width: 46%;
    }
  }

  .topDwfive {
    position: absolute;
    cursor: pointer;
    display: flex;
    flex-wrap: wrap;
    & .mybz:nth-child(1) {
      width: 37.5%;
    }
    & .mybz:nth-child(2) {
      width: 11%;
    }
    & .mybz:nth-child(3) {
      width: 11%;
    }
    & .mybz:nth-child(4) {
      width: 11%;
    }
  }

  .topWz {
    font-size: 18px;
    font-weight: 500;
    text-align: center;
    margin: 20px 0;
  }
}

.cententBox {
  position: absolute;
  top: 32.2%;
  left: 0%;
  // background-color: red;
  // background-image: url('../../assets/sybj.jpg');
  background-size: 100% 100.1%;
  background-repeat: no-repeat;
  // height: 30px;
  width: 100%;

  .centent {
    width: 90%;
    max-width: 1200px;
    margin: 0 auto;
    padding: 0 20px;
    box-sizing: border-box;

    .uploadZp {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 46px;
      width: 100%;
      margin-bottom: 90px;

      > div {
        width: 46%;
        border-radius: 50px;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #6598ed;
        cursor: pointer;
        // background-color: red;
      }
    }

    .dsgzBox {
      margin: 280px 30px 40px;
      padding-bottom: 90px;
      background-color: #fff;

      .dsgzBoxOne {
        margin-bottom: 50px;
        display: flex;

        .yuan {
          width: 14px;
          height: 14px;
          background-color: #663bfe;
          border-radius: 100%;
          margin-right: 26px;
          margin-top: 20px;
        }

        .dsgzBoxOneWz {
          flex: 1;
          max-width: calc(100% - 16px);
          font-size: 28px;
          font-family: "黑体";
          line-height: 48px;
        }

        // .dsgzBoxOneWz::before{
        // 	content: '';
        // 	width: 14px;
        // 	height: 14px;
        // 	background-color: #663bfe;
        // 	border-radius: 100%;
        // 	// margin-right: 26px;
        // 	display: inline-block;
        // }
      }

      .dsgzBoxTwo {
        display: flex;
        justify-content: end;
        font-size: 28px;
        font-family: "黑体";
        font-weight: 500;

        .dsgzBoxTwoOne {
        }

        .dsgzBoxTwoDssm {
          color: #3f66f2;
          cursor: pointer;
        }
      }
    }
  }
}
.bahbox {
  width: 100%;
  display: flex;
  justify-content: center;
  line-height: 100px;
  // font-size: 26px;
}
* {
  -webkit-tap-highlight-color: transparent;
}
</style>
